import Vue from 'vue';
import VueRouter from 'vue-router';
import { mapActions } from 'vuex';

import CryptoCurrencyPage from '@/components/CryptoCurrency/CryptoCurrencyPage';
import { i18n } from '@/i18n';
import router from '@/route/cryptocurrency';
import store from '@/store/cryptoCurrency';

// eslint-disable-next-line no-unused-vars
/* global context, dispatch */

Vue.use(VueRouter);

export function createApp () {
  const app = new Vue({ // eslint-disable-line no-new
    render(h) {
      return h(CryptoCurrencyPage);
    },
    i18n,
    store,
    router,
    serverPrefetch () {
      const { language, currency, market, interval, cryptoCurrency, isCorporateAccount, defaultBuyLink, defaultSellLink } = context;

      return this.initiateState(language, currency, market, interval, cryptoCurrency, isCorporateAccount, defaultBuyLink, defaultSellLink);
    },
    beforeMount () {
      if (this.$store.state.cryptoCurrency.description.length > 0) {
        return;
      }

      const { language, currency, market, interval, cryptoCurrency, isMemberPage, isCorporateAccount, defaultBuyLink, defaultSellLink } = this.$el.dataset;

      if (isMemberPage) {
        this.$store.commit('cryptoCurrency/setAsMemberPage');
      }

      this.initiateState(
        language,
        JSON.parse(currency),
        JSON.parse(market),
        JSON.parse(interval),
        JSON.parse(cryptoCurrency),
        isCorporateAccount,
        defaultBuyLink,
        defaultSellLink,
      ).finally(() => {
        const placeholderLoader = document.getElementById('placeholder-loader');
        if (placeholderLoader === null) {
          return;
        }

        placeholderLoader.style.display = 'none';
      });
    },
    methods: {
      ...mapActions({
        requestDescription: 'cryptoCurrency/requestDescription',
        requestMarketInfo: 'cryptoCurrency/requestMarketInfo',
        requestCryptoInfo: 'cryptoCurrency/requestCryptoInfo',
        requestAvailableFiats: 'cryptoCurrency/requestAvailableFiats',
        requestHistoricData: 'cryptoCurrency/requestHistoricData',
      }),
      initiateState (language, fiatCurrency, market, interval, cryptoCurrency, isCorporateAccount, defaultBuyLink, defaultSellLink) {
        this.$store.commit('cryptoCurrency/setCryptoCurrency', cryptoCurrency);
        this.$store.commit('cryptoCurrency/setFiatCurrency', fiatCurrency);
        this.$store.commit('cryptoCurrency/setMarket', market);
        this.$store.commit('cryptoCurrency/setTimeInterval', interval);
        this.$store.commit('language', language);
        this.$store.commit('cryptoCurrency/setIsCorporateAccount', Boolean(isCorporateAccount));
        this.$store.commit('cryptoCurrency/setDefaultBuyLink', defaultBuyLink);
        this.$store.commit('cryptoCurrency/setDefaultSellLink', defaultSellLink);

        return Promise.all([
          this.requestCryptoInfo()
            .then(() => {
              return Promise.all([
                this.requestMarketInfo({
                  market,
                  fiatCurrency,
                }),
                this.requestHistoricData({
                  market,
                  fiatCurrency,
                  timePeriod: interval,
                }),
              ]);
            }),
          this.requestDescription(language),
          this.requestAvailableFiats(),
        ]);
      },
    },
  });

  return { app, store, router };
}
